import React from 'react';

import {
	AuditAutoCheckFilters,
	AuditsAnalysisFilters,
	AuditsFilters,
} from '../modules/Audits/Configs/AuditsFilters';
import { ContactsModuleFilters } from '../modules/Contacts/Configs/ContactsFiltersConfig';
import { AudienceState } from '../models/Audiences';
import { AnswerState } from '../services/commons/AnswerState';
import { ItemStateFilter } from '../services/commons/ItemState';
import { ReplyState } from '../services/commons/ReplyState';
import { FrontRoleItemSummary } from '../services/commons/FrontRoles/FrontRoleItemSummary';

export interface IdelinkModuleFilters {
	list?: {
		selectedShops?: AudienceState;
		state?: ItemStateFilter | string;
	};
	results?: {
		selectedShops?: AudienceState;
		replyState?: ReplyState;
		answerState?: AnswerState;
	};
}

export interface FrontUserFilters extends IdelinkModuleFilters {
	list?: {
		selectedShops?: AudienceState;
		roles?: FrontRoleItemSummary[];
	};
}

export interface IdelinkFilters {
	//* MODULES
	offers: IdelinkModuleFilters; //* PACKAGEDS ORDER - GOODDEALS
	tunabledOffers: IdelinkModuleFilters; //* TUNABLE OFFERS

	operations: IdelinkModuleFilters;
	engagements: IdelinkModuleFilters;

	communications: IdelinkModuleFilters;
	digitalMarketings: IdelinkModuleFilters;
	partnerships: IdelinkModuleFilters;
	leaflets: IdelinkModuleFilters;

	events: IdelinkModuleFilters;

	videos: IdelinkModuleFilters;
	surveys: IdelinkModuleFilters;
	news: IdelinkModuleFilters;
	challenges: IdelinkModuleFilters;
	indicators: IdelinkModuleFilters;
	quizzes: IdelinkModuleFilters;
	collections: IdelinkModuleFilters;

	audits: AuditsFilters;
	auditThemes: IdelinkModuleFilters;
	auditsAutoChecks: AuditAutoCheckFilters;
	auditAnalysis: AuditsAnalysisFilters;

	gondoles: IdelinkModuleFilters;
	contacts: ContactsModuleFilters;

	frontUsers: FrontUserFilters;
}
export const DefaultIdelinkFilters: IdelinkFilters = {
	//* MODULES
	offers: {}, //* PACKAGEDS ORDER - GOODDEALS,
	tunabledOffers: {}, //* TUNABLE OFFERS

	operations: {},
	engagements: {},

	communications: {},
	digitalMarketings: {},
	partnerships: {},
	leaflets: {},

	events: {},

	videos: {},
	surveys: {},
	news: {},
	quizzes: {},
	gondoles: {},
	collections: {},

	challenges: {},
	indicators: {},

	audits: {},
	auditThemes: {},
	auditsAutoChecks: {},
	auditAnalysis: {},

	contacts: {},
	frontUsers: {},
};

export type IdelinkFiltersConfig = { enabled?: boolean; filtersName: string };
export const DefaultFiltersConfig: IdelinkFiltersConfig = { filtersName: 'idelink-filters' };

export const FiltersContext = React.createContext<IdelinkFiltersConfig>(DefaultFiltersConfig);
export const useIdelinkFiltersConfig = (): IdelinkFiltersConfig => React.useContext(FiltersContext);
